import {
  DEFINITION_ROUTE_DEVELOPER_DASHBOARD_APPLICATION,
  ROUTE_DEVELOPER_DASHBOARD,
} from '@developer/constants';

export function isCurrentRouteIsDeveloperDashboard(): boolean {
  return window.location.pathname === ROUTE_DEVELOPER_DASHBOARD;
}

export function isCurrentRouteIsDeveloperDashboardApplication(): boolean {
  return window.location.pathname.includes(
    DEFINITION_ROUTE_DEVELOPER_DASHBOARD_APPLICATION
  );
}